import React, { Component } from 'react';
import { DashboardCard } from './DashboardCard';
import { BarChart3Icon, TruckIcon, DollarSignIcon, ClipboardCheckIcon, BadgeIcon, ArrowUpIcon, ArrowDownIcon, TrendingUpIcon, MapIcon, GlobeIcon, UsersIcon, CheckCircleIcon, XCircleIcon, MoreHorizontalIcon } from 'lucide-react';
export function DashboardOverview() {
  return <div className="space-y-6" data-id="element-1189">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1190">
        <StatCard title="Active Orders" value="22" trend="+4" trendLabel="from last month" trendUp={true} icon={<TruckIcon size={20} className="text-indigo-400" data-id="element-1192" />} color="indigo" data-id="element-1191" />
        <StatCard title="Total Quotes" value="2,392" trend="+152" trendLabel="from last month" trendUp={true} icon={<DollarSignIcon size={20} className="text-blue-400" data-id="element-1194" />} color="blue" data-id="element-1193" />
        <StatCard title="Warranty Claims" value="125" trend="-12" trendLabel="from last month" trendUp={false} icon={<ClipboardCheckIcon size={20} className="text-emerald-400" data-id="element-1196" />} color="emerald" data-id="element-1195" />
        <StatCard title="Active Subscriptions" value="991" trend="+38" trendLabel="from last month" trendUp={true} icon={<BadgeIcon size={20} className="text-violet-400" data-id="element-1198" />} color="violet" data-id="element-1197" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1199">
        <DashboardCard title="Regional Distribution" icon={<GlobeIcon size={20} className="text-blue-400" data-id="element-1201" />} className="lg:col-span-2" data-id="element-1200">
          <div className="h-80 relative" data-id="element-1202">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-1203">
              <div className="grid grid-cols-2 gap-4 w-full max-w-2xl px-6" data-id="element-1204">
                <RegionStat name="EUROPE" value="820" percentage={75} color="blue" data-id="element-1205" />
                <RegionStat name="AMERICA" value="180" percentage={45} color="indigo" data-id="element-1206" />
                <RegionStat name="MENA" value="10" percentage={15} color="emerald" data-id="element-1207" />
                <RegionStat name="AFRICA" value="20" percentage={25} color="amber" data-id="element-1208" />
                <RegionStat name="LATAM" value="160" percentage={40} color="rose" data-id="element-1209" />
                <RegionStat name="ANZ" value="150" percentage={35} color="violet" data-id="element-1210" />
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard title="Performance Overview" icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1212" />} data-id="element-1211">
          <div className="space-y-6" data-id="element-1213">
            <div data-id="element-1214">
              <div className="flex justify-between mb-2" data-id="element-1215">
                <span className="text-sm text-blue-300" data-id="element-1216">Orders Completion</span>
                <span className="text-sm font-medium text-white" data-id="element-1217">78%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-1218">
                <div className="bg-indigo-500 h-2 rounded-full" style={{
                width: '78%'
              }} data-id="element-1219"></div>
              </div>
            </div>
            <div data-id="element-1220">
              <div className="flex justify-between mb-2" data-id="element-1221">
                <span className="text-sm text-blue-300" data-id="element-1222">Quote Conversion</span>
                <span className="text-sm font-medium text-white" data-id="element-1223">42%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-1224">
                <div className="bg-blue-500 h-2 rounded-full" style={{
                width: '42%'
              }} data-id="element-1225"></div>
              </div>
            </div>
            <div data-id="element-1226">
              <div className="flex justify-between mb-2" data-id="element-1227">
                <span className="text-sm text-blue-300" data-id="element-1228">
                  Warranty Resolution
                </span>
                <span className="text-sm font-medium text-white" data-id="element-1229">92%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-1230">
                <div className="bg-emerald-500 h-2 rounded-full" style={{
                width: '92%'
              }} data-id="element-1231"></div>
              </div>
            </div>
            <div data-id="element-1232">
              <div className="flex justify-between mb-2" data-id="element-1233">
                <span className="text-sm text-blue-300" data-id="element-1234">
                  Subscription Renewal
                </span>
                <span className="text-sm font-medium text-white" data-id="element-1235">86%</span>
              </div>
              <div className="w-full bg-slate-700/50 rounded-full h-2" data-id="element-1236">
                <div className="bg-violet-500 h-2 rounded-full" style={{
                width: '86%'
              }} data-id="element-1237"></div>
              </div>
            </div>
          </div>
        </DashboardCard>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1238">
        <DashboardCard title="Top Dealers" icon={<UsersIcon size={20} className="text-blue-400" data-id="element-1240" />} data-id="element-1239">
          <div className="space-y-4" data-id="element-1241">
            {['TEXAS INTERNATIONAL IRRIGATION', 'UWR', 'I-BEAM Irrigation', 'AQUADOC', 'NORTHERN IRRIGATION SYSTEMS'].map((dealer, index) => <div key={index} className="flex items-center" data-id="element-1242">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center mr-3" data-id="element-1243">
                  <span className="text-white text-xs font-bold" data-id="element-1244">
                    {dealer.split(' ').map(word => word[0]).join('')}
                  </span>
                </div>
                <div className="flex-1" data-id="element-1245">
                  <div className="text-sm font-medium text-white" data-id="element-1246">{dealer}</div>
                  <div className="flex items-center mt-1" data-id="element-1247">
                    <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1248">
                      <div className="bg-blue-500 h-1.5 rounded-full" style={{
                    width: `${100 - index * 10}%`
                  }} data-id="element-1249"></div>
                    </div>
                    <span className="ml-2 text-xs text-blue-300" data-id="element-1250">
                      {167 - index * 15}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </DashboardCard>
        <DashboardCard title="Recent Activity" icon={<TrendingUpIcon size={20} className="text-blue-400" data-id="element-1252" />} data-id="element-1251">
          <div className="space-y-4" data-id="element-1253">
            <ActivityItem title="New order received" description="Order #HX6AA6-3 from AGRICULTURAL SERVICES Inc" time="2 hours ago" icon={<TruckIcon size={16} className="text-indigo-400" data-id="element-1255" />} iconBg="bg-indigo-500/20" data-id="element-1254" />
            <ActivityItem title="Quote approved" description="Quote #DKEYFH-1 for $64,699.26" time="5 hours ago" icon={<CheckCircleIcon size={16} className="text-emerald-400" data-id="element-1257" />} iconBg="bg-emerald-500/20" data-id="element-1256" />
            <ActivityItem title="Warranty claim rejected" description="Claim #WC-2023-089 for missing parts" time="Yesterday" icon={<XCircleIcon size={16} className="text-rose-400" data-id="element-1259" />} iconBg="bg-rose-500/20" data-id="element-1258" />
            <ActivityItem title="New subscription activated" description="iCRcell subscription for VK SALES & SERVICE" time="2 days ago" icon={<BadgeIcon size={16} className="text-violet-400" data-id="element-1261" />} iconBg="bg-violet-500/20" data-id="element-1260" />
            <ActivityItem title="Quote converted to order" description="Quote #ZAK096-2 for $189,847.68" time="3 days ago" icon={<DollarSignIcon size={16} className="text-blue-400" data-id="element-1263" />} iconBg="bg-blue-500/20" data-id="element-1262" />
          </div>
        </DashboardCard>
        <DashboardCard title="Issue Analysis" icon={<ClipboardCheckIcon size={20} className="text-blue-400" data-id="element-1265" />} data-id="element-1264">
          <div className="space-y-4" data-id="element-1266">
            <div className="flex items-center justify-between mb-2" data-id="element-1267">
              <h3 className="text-sm font-medium text-blue-300" data-id="element-1268">Top Issues</h3>
              <button className="text-blue-400 hover:text-white" data-id="element-1269">
                <MoreHorizontalIcon size={16} data-id="element-1270" />
              </button>
            </div>
            <IssueItem name="Leaks and Seal Damage" count={40} percentage={40} color="blue" data-id="element-1271" />
            <IssueItem name="Electrical Components" count={18} percentage={18} color="amber" data-id="element-1272" />
            <IssueItem name="Wheel and Tire Issues" count={30} percentage={30} color="red" data-id="element-1273" />
            <IssueItem name="Engine Failures" count={25} percentage={25} color="rose" data-id="element-1274" />
            <IssueItem name="Structure Issues" count={30} percentage={30} color="emerald" data-id="element-1275" />
            <IssueItem name="Manufacturing Defects" count={35} percentage={35} color="indigo" data-id="element-1276" />
          </div>
        </DashboardCard>
      </div>
    </div>;
}
function StatCard({
  title,
  value,
  trend,
  trendLabel,
  trendUp,
  icon,
  color
}) {
  const colors = {
    blue: 'from-blue-500/20 to-blue-600/20 border-blue-500/30',
    indigo: 'from-indigo-500/20 to-indigo-600/20 border-indigo-500/30',
    emerald: 'from-emerald-500/20 to-emerald-600/20 border-emerald-500/30',
    violet: 'from-violet-500/20 to-violet-600/20 border-violet-500/30'
  };
  return <div className={`bg-gradient-to-br ${colors[color]} border rounded-xl p-5`} data-id="element-1277">
      <div className="flex justify-between items-start mb-4" data-id="element-1278">
        <div className="p-2 rounded-lg bg-slate-800/50" data-id="element-1279">{icon}</div>
        <div className={`flex items-center px-2 py-1 rounded-full text-xs font-medium ${trendUp ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`} data-id="element-1280">
          {trendUp ? <ArrowUpIcon size={12} className="mr-1" data-id="element-1281" /> : <ArrowDownIcon size={12} className="mr-1" data-id="element-1282" />}
          {trend}
        </div>
      </div>
      <div className="text-2xl font-bold text-white mb-1" data-id="element-1283">{value}</div>
      <div className="text-sm text-blue-300" data-id="element-1284">{title}</div>
      <div className="mt-3 text-xs text-blue-400" data-id="element-1285">{trendLabel}</div>
    </div>;
}
function RegionStat({
  name,
  value,
  percentage,
  color
}) {
  const colors = {
    blue: 'bg-blue-500',
    indigo: 'bg-indigo-500',
    emerald: 'bg-emerald-500',
    amber: 'bg-amber-500',
    rose: 'bg-rose-500',
    violet: 'bg-violet-500'
  };
  return <div className="bg-slate-800/70 rounded-lg p-3" data-id="element-1286">
      <div className="flex justify-between items-center mb-2" data-id="element-1287">
        <span className="text-sm font-medium text-white" data-id="element-1288">{name}</span>
        <span className="text-sm text-blue-300" data-id="element-1289">{value}</span>
      </div>
      <div className="w-full bg-slate-700 rounded-full h-1.5" data-id="element-1290">
        <div className={`${colors[color]} h-1.5 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-1291"></div>
      </div>
    </div>;
}
function ActivityItem({
  title,
  description,
  time,
  icon,
  iconBg
}) {
  return <div className="flex" data-id="element-1292">
      <div className={`w-8 h-8 rounded-full ${iconBg} flex items-center justify-center mr-3 flex-shrink-0`} data-id="element-1293">
        {icon}
      </div>
      <div data-id="element-1294">
        <div className="text-sm font-medium text-white" data-id="element-1295">{title}</div>
        <div className="text-xs text-blue-300" data-id="element-1296">{description}</div>
        <div className="text-xs text-slate-400 mt-1" data-id="element-1297">{time}</div>
      </div>
    </div>;
}
function IssueItem({
  name,
  count,
  percentage,
  color
}) {
  const colors = {
    blue: 'bg-blue-500',
    indigo: 'bg-indigo-500',
    emerald: 'bg-emerald-500',
    amber: 'bg-amber-500',
    red: 'bg-red-500',
    rose: 'bg-rose-500'
  };
  return <div data-id="element-1298">
      <div className="flex justify-between mb-1" data-id="element-1299">
        <span className="text-xs text-blue-300" data-id="element-1300">{name}</span>
        <span className="text-xs font-medium text-white" data-id="element-1301">{count}</span>
      </div>
      <div className="w-full bg-slate-700/50 rounded-full h-1.5" data-id="element-1302">
        <div className={`${colors[color]} h-1.5 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-1303"></div>
      </div>
    </div>;
}